import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutComponent } from './checkout/checkout.component';
import { OrderCheckoutModule } from './checkout/order-checkout.module';

@NgModule({
  declarations: [CheckoutComponent],
  imports: [
    CommonModule,
    OrderCheckoutModule,
  ]

})
export class CheckoutModule { }
